/* SAHKA - comportements front personnalises. Charge sur toutes les pages. */
(function () {
  'use strict';

  /* Le rail est positionne en absolu dans la vignette plutot qu'en
     hauteur 100% : sur iOS, un enfant flex en height:100% dans un
     conteneur dimensionne par aspect-ratio peut se calculer a 0,
     ce qui donnait une grande zone noire a la place de la photo. */
  var CSS = [
    '.mcp-gal .mcp-main.sk-rail-on{display:block;padding:0;position:relative}',
    '.sk-rail{position:absolute;inset:0;display:flex;overflow-x:auto;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;scrollbar-width:none}',
    '.sk-rail::-webkit-scrollbar{display:none}',
    '.sk-slide{flex:0 0 100%;height:100%;scroll-snap-align:center;scroll-snap-stop:always;margin:0;position:relative}',
    '.sk-slide img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block}',
    '.sk-dots{display:flex;justify-content:center;align-items:center;gap:7px;margin:12px 0 4px}',
    '.sk-dots button{width:7px;height:7px;padding:0;border:0;border-radius:999px;background:#2a2a35;cursor:pointer;transition:width .2s ease,background .2s ease}',
    '.sk-dots button.is-on{width:20px;background:#c9a227}',
    '.sk-arrow{position:absolute;top:50%;transform:translateY(-50%);z-index:3;width:38px;height:38px;border-radius:999px;border:0;cursor:pointer;background:rgba(7,7,10,.55);color:#fff;font-size:18px;line-height:1;display:none;align-items:center;justify-content:center;transition:background .2s ease}',
    '.sk-arrow:hover{background:rgba(7,7,10,.85)}',
    '.sk-arrow[hidden]{display:none!important}',
    '.sk-prev{left:12px}.sk-next{right:12px}',
    '@media (hover:hover) and (min-width:901px){.sk-arrow{display:flex}}',
    '@media (max-width:900px){.sk-dots{margin:10px 0 2px}}'
  ].join('');

  function injectCss() {
    if (document.getElementById('sk-custom-css')) return;
    var s = document.createElement('style');
    s.id = 'sk-custom-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function initGallery() {
    var main = document.querySelector('.mcp-gal .mcp-main');
    if (!main || main.classList.contains('sk-rail-on')) return;

    var hero = document.getElementById('mcp-img');
    var thumbs = [].slice.call(document.querySelectorAll('.mcp-gal .mcp-th'));
    var srcs = thumbs.map(function (t) { return t.getAttribute('data-src'); }).filter(Boolean);

    if (srcs.length < 2) return;
    if (hero && hero.getAttribute('src') && srcs.indexOf(hero.getAttribute('src')) === -1) {
      srcs.unshift(hero.getAttribute('src'));
    }

    injectCss();

    var alt = hero ? (hero.getAttribute('alt') || '') : '';
    var rail = document.createElement('div');
    rail.className = 'sk-rail';

    srcs.forEach(function (src, i) {
      var slide = document.createElement('figure');
      slide.className = 'sk-slide';
      var im = document.createElement('img');
      im.src = src;
      im.alt = alt ? alt + ' - vue ' + (i + 1) : '';
      im.draggable = false;
      if (i > 0) im.loading = 'lazy';
      slide.appendChild(im);
      rail.appendChild(slide);
    });

    if (hero) hero.style.display = 'none';
    main.classList.add('sk-rail-on');
    main.appendChild(rail);

    /* Filet de securite : si pour une raison quelconque le rail ne
       prend aucune hauteur, on remet la photo d'origine plutot que
       de laisser un rectangle noir. */
    function bail() {
      main.classList.remove('sk-rail-on');
      if (rail.parentNode) rail.parentNode.removeChild(rail);
      var d = document.querySelector('.mcp-gal .sk-dots');
      if (d && d.parentNode) d.parentNode.removeChild(d);
      [].slice.call(main.querySelectorAll('.sk-arrow')).forEach(function (a) { a.remove(); });
      if (hero) hero.style.display = '';
    }
    setTimeout(function () {
      if (rail.getBoundingClientRect().height < 40) bail();
    }, 400);

    var dots = document.createElement('div');
    dots.className = 'sk-dots';
    srcs.forEach(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Image ' + (i + 1));
      dots.appendChild(b);
    });
    main.parentNode.insertBefore(dots, main.nextSibling);
    var dotEls = [].slice.call(dots.children);

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'sk-arrow sk-prev';
    prev.setAttribute('aria-label', 'Image precedente');
    prev.innerHTML = '&#10094;';
    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'sk-arrow sk-next';
    next.setAttribute('aria-label', 'Image suivante');
    next.innerHTML = '&#10095;';
    main.appendChild(prev);
    main.appendChild(next);

    var index = 0;

    function setActive(i) {
      index = i;
      dotEls.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      prev.hidden = i <= 0;
      next.hidden = i >= srcs.length - 1;
    }

    function goTo(i, smooth) {
      i = Math.max(0, Math.min(srcs.length - 1, i));
      var w = rail.clientWidth || main.clientWidth;
      try { rail.scrollTo({ left: w * i, behavior: smooth === false ? 'auto' : 'smooth' }); }
      catch (e) { rail.scrollLeft = w * i; }
      setActive(i);
    }

    var t;
    rail.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var w = rail.clientWidth || 1;
        var i = Math.round(rail.scrollLeft / w);
        if (i !== index) setActive(i);
      }, 70);
    }, { passive: true });

    dotEls.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });
    prev.addEventListener('click', function () { goTo(index - 1); });
    next.addEventListener('click', function () { goTo(index + 1); });

    if (hero && window.MutationObserver) {
      new MutationObserver(function () {
        var k = srcs.indexOf(hero.getAttribute('src'));
        if (k > -1 && k !== index) goTo(k);
      }).observe(hero, { attributes: true, attributeFilter: ['src'] });
    }

    document.addEventListener('keydown', function (e) {
      if (!rail.getBoundingClientRect().height) return;
      if (e.key === 'ArrowLeft') goTo(index - 1);
      if (e.key === 'ArrowRight') goTo(index + 1);
    });

    setActive(0);
  }

  function boot() {
    try { initGallery(); } catch (e) { /* ne jamais casser la page */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', boot);
})();
